import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingTop: "32px",
      paddingBottom: "32px",
      margin: "auto",
      marginTop: "150px",
      display: "flex",
      flexDirection: "column",
      width: "600px",
      minHeight: "350px",
      alignItems: "center",
      justifyContent: "space-around",
      backgroundColor: "white",
    },
    header: {
      fontWeight: "bold",
      fontSize: "18px",
    },
    inputRoot: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      width: "500px",
    },
    inputItem: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "12px",
    },
    textField: {
      position: "relative",
      marginBottom: "12px",
    },
    buttonBase: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-around",
      width: "100%",
      marginBottom: "12px",
    },
    button: {
      minWidth: "200px",
      textTransform: "none",
    },
    errorTypo: {
      color: "red",
    },
    inputLabel: {
      color: theme.palette.primary.main,
    },
    helperText: {
      position: "absolute",
      bottom: "-22px",
      whiteSpace: "nowrap",
      width: "100%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      color: "#f44336",
    },
  });
